const PROFILE_ROUTE_PREFIX = '/profile/';

export type ProfileIdentifierInput = {
  id?: string | number | null;
  username?: string | null;
};

export function getProfileIdentifier(input: ProfileIdentifierInput): string {
  const username = input.username?.trim();
  if (username) return username;
  return String(input.id ?? '');
}

export function getProfilePath(input: ProfileIdentifierInput): string {
  const identifier = getProfileIdentifier(input);
  return `${PROFILE_ROUTE_PREFIX}${encodeURIComponent(identifier)}`;
}

export function getAbsoluteProfileUrl(input: ProfileIdentifierInput): string {
  if (typeof window === 'undefined') return getProfilePath(input);
  return new URL(getProfilePath(input), window.location.origin).toString();
}
